import { PAYMENT_IFRAME_MESSAGE_SOURCE } from './reportFrameHeight';
import { resolveStoreBaseUrl } from './resolveStoreBaseUrl';

export type SessionExpiredStoreAction = 'home' | 'login' | 'contact';

export const STORE_NAVIGATE_MESSAGE_TYPE = 'store-navigate';

const STORE_PATH: Record<SessionExpiredStoreAction, string> = {
  home: '/',
  login: '/login',
  contact: '/contacto',
};

const isEmbeddedInHost = (): boolean => {
  try {
    return window.parent !== window;
  } catch {
    return true;
  }
};

export const buildSessionExpiredStoreUrl = (
  action: SessionExpiredStoreAction,
): string | undefined => {
  const storeBaseUrl = resolveStoreBaseUrl();
  if (!storeBaseUrl) return undefined;

  const workspace = import.meta.env.VITE_STORE_WORKSPACE?.trim();
  const url = new URL(STORE_PATH[action], storeBaseUrl);
  if (workspace && workspace !== 'master' && /^[a-z0-9-]+$/i.test(workspace)) {
    url.searchParams.set('workspace', workspace);
  }
  return url.toString();
};

const postToHost = (action: SessionExpiredStoreAction): void => {
  const message = {
    source: PAYMENT_IFRAME_MESSAGE_SOURCE,
    type: STORE_NAVIGATE_MESSAGE_TYPE,
    action,
  };
  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
    return;
  }
  if (isEmbeddedInHost()) {
    window.parent.postMessage(message, '*');
  }
};

/** Aviso al host embebido (checkout web / app RN). En web, la navegación la hace `<a target="_top">`. */
export const notifySessionExpiredNavigation = (action: SessionExpiredStoreAction): void => {
  if (window.ReactNativeWebView?.postMessage || isEmbeddedInHost()) {
    postToHost(action);
  }
};

export const requestSessionExpiredAction = notifySessionExpiredNavigation;
